(function() {
    var __webpack_require__ = {};
    !function() {
        __webpack_require__.r = function(exports) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
            }
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
        };
    }();
    var __webpack_exports__ = {};
    !function() {
        class BannerGridMobileSwiper extends HTMLElement {
            constructor() {
                super();
                this.swiper = null;
                this.mediaQuery = window.matchMedia("(max-width: 749px)");
                this.handleViewportChange = this.handleViewportChange.bind(this);
            }
            connectedCallback() {
                this.handleViewportChange();
                this.mediaQuery.addEventListener("change", this.handleViewportChange);
            }
            disconnectedCallback() {
                this.destroySwiper();
                this.mediaQuery.removeEventListener("change", this.handleViewportChange);
            }
            handleViewportChange() {
                if (this.mediaQuery.matches) {
                    this.initSwiper();
                    return;
                }
                this.destroySwiper();
            }
            initSwiper() {
                if (this.swiper || typeof Swiper === "undefined") {
                    return;
                }
                this.swiper = new Swiper(this.querySelector(".banner-grid__swiper"), {
                    slidesPerView: 1,
                    spaceBetween: Number(getComputedStyle(this).getPropertyValue("--cell-spacing").replace("px", "")) || 0,
                    pagination: {
                        el: this.querySelector(".banner-grid__mobile-pagination"),
                        clickable: true
                    },
                    navigation: {
                        nextEl: this.querySelector(".banner-grid__mobile-next"),
                        prevEl: this.querySelector(".banner-grid__mobile-prev")
                    }
                });
            }
            destroySwiper() {
                if (!this.swiper) {
                    return;
                }
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }
        if (!window.customElements.get("banner-grid-mobile-swiper")) {
            window.customElements.define("banner-grid-mobile-swiper", BannerGridMobileSwiper);
        }
    }();
    !function() {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
    }();
})();